import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-jira-comments',
  templateUrl: './jira-comments.component.html',
  styleUrls: ['./jira-comments.component.scss']
})
export class JiraCommentsComponent implements OnInit {
  @Input() jiraComments: any[];

  constructor() {
  }

  ngOnInit() {
  }
}
